export function concatStrings(strings: string[]): string {
  return strings.join(" and ");
}
